import { produce } from "immer";
import {
  FLEXI_ACCESS_INCOME_FETCH_FAILURE,
  FLEXI_ACCESS_INCOME_FETCH_SUCCESS,
  FLEXI_ACCESS_INCOME_FETCH_START,
} from "../actions/types";

const flexiAccessIncome = (
  state = {
    flexiAccessFetching: false,
    flexiAccessData: [],
    flexiAccessError: null,
  },
  action,
) => {
  switch (action.type) {
    case FLEXI_ACCESS_INCOME_FETCH_START:
      return produce(state, (draft) => {
        draft.flexiAccessFetching = true;
      });
    case FLEXI_ACCESS_INCOME_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.flexiAccessFetching = true;
        draft.flexiAccessData = action.data;
        draft.flexiAccessFetching = false;
      });
    case FLEXI_ACCESS_INCOME_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.flexiAccessFetching = false;
        draft.flexiAccessError = action.error;
      });
    default:
      return state;
  }
};

export default flexiAccessIncome;
